module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-1 my-2"
  }, [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "headline ma-0 grey--text text--darken-2"
  }, [_vm._v(" " + _vm._s(_vm.fa.name) + " ")])])], 1), _vm._v(" "), _c('v-container', {
    staticClass: "px-2",
    attrs: {
      "grid-list-xs": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.fa.adressen), function(adresse) {
    return _c('div', {
      key: adresse.id
    }, [_c('p', {
      staticClass: "mt-1"
    }, [_vm._v("\n                    " + _vm._s(adresse.strasse) + " "), _c('br'), _vm._v("\n                    " + _vm._s(adresse.plz) + " " + _vm._s(adresse.ort) + "   \n                    ")]), _vm._v(" "), _c('v-divider')], 1)
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "mt-1"
  }, [_c('v-icon', [_vm._v("phone")]), _vm._v(" " + _vm._s(_vm.fa.telefon) + "  "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("print")]), _vm._v(" " + _vm._s(_vm.fa.fax) + " \n                ")], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "mt-1"
  }, [_c('v-icon', [_vm._v("mail")]), _vm._v(" " + _vm._s(_vm.fa.email) + " "), _c('br'), _vm._v(" "), _c('v-icon', [_vm._v("language")]), _vm._v(" " + _vm._s(_vm.fa.web) + "                 \n                ")], 1)])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey darken-3 mt-2 pa-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.gotoEdit(_vm.fa.id)
      }
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("build")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.commitDelete
    }
  }, [_c('v-icon', {
    staticClass: "grey--text text--darken-1"
  }, [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('delete-modal', {
    attrs: {
      "showDialog": _vm.showDialog
    },
    on: {
      "update:showDialog": function($event) {
        _vm.showDialog = $event
      },
      "committed": _vm.toDestroy
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74da283c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/firmen/singleFirmen.vue
// module id = 329
// module chunks = 0